import React from 'react';
import { Form, Input } from 'antd';
import { Rule } from 'antd/es/form';
import { Catcher, FormSelect } from '../../';
import { useCardSetsSelect } from '../../../hooks';
import { ITrField, tF } from '../../../translate';

export enum AdvancedFieldTypes {
    INPUT,
    SELECT_CARD_SETS,
}

export type IAdvancedField = {
    isLoading?: boolean;
    label?: ITrField;
    name: string;
    placeholder?: ITrField;
    rules?: Rule[];
    type: AdvancedFieldTypes;
};
export const AdvancedField: React.FC<IAdvancedField> = ({
    isLoading,
    name,
    rules,
    label,
    placeholder,
    type,
}: IAdvancedField) => {
    const labelText = label ? tF(label) : '';
    const placeholderText = placeholder ? tF(placeholder) : labelText;
    return (
        <Catcher>
            {type === AdvancedFieldTypes.INPUT ? (
                <Form.Item name={name} rules={rules} label={labelText}>
                    <Input placeholder={placeholderText} disabled={isLoading} />
                </Form.Item>
            ) : null}
            {type === AdvancedFieldTypes.SELECT_CARD_SETS ? (
                <FormSelect
                    fieldName={name}
                    label={labelText}
                    mode={'multiple'}
                    rules={rules}
                    useSelectHook={useCardSetsSelect}
                    isNotClear={true}
                    disabled={isLoading}
                />
            ) : null}
        </Catcher>
    );
};
